import { Contract, hash, num, addAddressPadding } from 'starknet';
import { LockStatus } from '@train-protocol/sdk';
import htlcAbi from '../abis/STARKNET_HTLC.json' with { type: 'json' };
export function createContract(address, providerOrAccount) {
    return new Contract({ abi: htlcAbi, address, providerOrAccount });
}
export function mapLockStatus(cairoStatus) {
    // CairoCustomEnum — activeVariant is a METHOD, must be called
    if (typeof cairoStatus?.activeVariant === 'function') {
        const variant = cairoStatus.activeVariant();
        switch (variant) {
            case 'Pending': return LockStatus.Pending;
            case 'Redeemed': return LockStatus.Redeemed;
            case 'Refunded': return LockStatus.Refunded;
            default: return LockStatus.Empty;
        }
    }
    // Fallback: plain number/bigint
    if (typeof cairoStatus === 'number' || typeof cairoStatus === 'bigint') {
        return Number(cairoStatus);
    }
    // Fallback: { variant: { Refunded: {}, ... } } — active key has an object value
    if (cairoStatus?.variant && typeof cairoStatus.variant === 'object') {
        const variantKey = Object.keys(cairoStatus.variant).find(k => cairoStatus.variant[k] !== undefined);
        switch (variantKey) {
            case 'Pending': return LockStatus.Pending;
            case 'Redeemed': return LockStatus.Redeemed;
            case 'Refunded': return LockStatus.Refunded;
            default: return LockStatus.Empty;
        }
    }
    return LockStatus.Empty;
}
export async function findUserLockedEvent(provider, txHash, matchHashlock) {
    const receipt = await provider.getTransactionReceipt(txHash);
    if (!receipt || !('events' in receipt))
        return null;
    const userLockedSelector = hash.getSelectorFromName('UserLocked');
    const rawEvent = receipt.events.find(e => e.keys.includes(userLockedSelector));
    if (!rawEvent)
        return null;
    const contract = createContract(rawEvent.from_address, provider);
    const parsed = contract.parseEvents(receipt);
    const userLockedEntry = parsed.find(ev => Object.keys(ev).some(k => k.includes('UserLocked')));
    if (!userLockedEntry)
        return null;
    const eventKey = Object.keys(userLockedEntry).find(k => k.includes('UserLocked'));
    const event = userLockedEntry[eventKey];
    if (matchHashlock) {
        const eventHashlock = addAddressPadding(num.toHex(event.hashlock));
        if (eventHashlock.toLowerCase() !== matchHashlock.toLowerCase())
            return null;
    }
    return event;
}
export function pickStarknetEventData(event) {
    const data = {};
    if (event.dst_chain != null)
        data.dstChain = event.dst_chain;
    if (event.dst_address != null)
        data.dstAddress = event.dst_address;
    if (event.dst_amount != null)
        data.dstAmount = BigInt(event.dst_amount);
    if (event.dst_token != null) {
        const raw = event.dst_token;
        data.dstToken = !raw || /^[\u0000]+$/.test(raw) ? '0x0000000000000000000000000000000000000000' : raw;
    }
    if (event.userData != null || event.user_data != null)
        data.userData = (event.userData ?? event.user_data);
    if (event.solverData != null || event.solver_data != null)
        data.solverData = (event.solverData ?? event.solver_data);
    return data;
}
